
import postcssStyledJsxUrlLoader_0 from '../../../../library/images/edge-texture.svg';
import css from 'styled-jsx/css';

export default css`.customer__story-wrap {
  display: grid;
  position: relative;
}

.customer__story-wrap:before,
.customer__story-wrap:after {
  content: '';
  position: absolute;
  height: 18px;
  left: 0;
  right: 0;
  bottom: -18px;
  mask-image: url("${postcssStyledJsxUrlLoader_0}");
  mask-repeat: repeat no-repeat;
  width: 100vw;
  z-index: -1;
}

.customer__story-wrap:before {
  top: -18px;
  bottom: auto;
  transform: scaleY(-1);
}

.customer__story-header {
  display: flex;
  justify-content: space-between;

  @include media-query(mobile) {
    align-items: flex-end;
  }
}

:global(.customer__story-header > span) {
  @include media-query(mobile) {
    max-width: 220px;
  }
}

:global(.customer__story-header a > span) {
  @include media-query(mobile) {
    font-weight: 100;
  }
}

.customer__story {
  display: grid;
  grid-column: content;
  max-width: $container-max-width;
  width: 100%;
  margin: 0 auto;
}

.customer__story-grid {
  display: grid;
  grid-template-columns: 1fr;
}

.customer__story-viewall {
  min-width: 90px;
  margin-top: auto;
  flex-direction: column;
  display: inline-flex;
}
`